import { css } from "@emotion/css";
import { ErrorPanel } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import type { OctopusError } from "@octopusdeploy/octopus-server-client";
import { createErrorInfo } from "~/areas/tasks/components/Task/Kubernetes/createErrorInfo";
import type { PagedOnboardingDialogPageData } from "~/components/OnboardingDialog/PagedOnboardingDialog";
export function getKubernetesMonitorDialogErrorPage(error: Error | OctopusError): PagedOnboardingDialogPageData {
    // We know error is defined, so errorInfo will be defined too
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const errorInfo = createErrorInfo(error)!;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if ((error as OctopusError)?.StatusCode === 403) {
        return {
            name: "Insufficient access to upgrade Kubernetes agents",
            title: "Insufficient access to upgrade Kubernetes agents",
            helpPanelHidden: true,
            render: () => (<div>
                    <p className={styles.paragraphWithSpace}>You don't have permissions to view Kubernetes agents in this space.</p>
                    <p>Ask your space manager to upgrade your agents to support live status.</p>
                </div>),
            alwaysShowCloseButton: true,
            onlyShowCloseButton: true,
        };
    }
    return {
        name: "Failed to fetch Kubernetes agents",
        title: "Failed to fetch Kubernetes agents",
        helpPanelHidden: true,
        render: () => <ErrorPanel error={errorInfo}/>,
        alwaysShowCloseButton: true,
        onlyShowCloseButton: true,
    };
}
const styles = {
    paragraphWithSpace: css({ paddingBottom: space[16] }),
};
